var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconMenuFacebook(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.806,
    height: 17.806,
    viewBox: "0 0 17.806 17.806",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "FontAwsome_facebook-square_",
    "data-name": "FontAwsome (facebook-square)",
    d: "M15.9,32H1.908A1.908,1.908,0,0,0,0,33.908V47.9a1.908,1.908,0,0,0,1.908,1.908H7.363V43.752h-2.5V40.9h2.5V38.731A3.478,3.478,0,0,1,11.086,34.9a15.169,15.169,0,0,1,2.207.192v2.424H12.05a1.425,1.425,0,0,0-1.607,1.539V40.9h2.734l-.437,2.849h-2.3v6.054H15.9A1.908,1.908,0,0,0,17.806,47.9V33.908A1.908,1.908,0,0,0,15.9,32Z",
    transform: "translate(0 -32)",
    fill: "#816920"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMenuFacebook);
export default __webpack_public_path__ + "static/media/icon-menu-facebook.ca3a5a7b.svg";
export { ForwardRef as ReactComponent };